import { render, staticRenderFns } from "./ServiceBuildingSelector.vue?vue&type=template&id=6ec4a672"
import script from "./ServiceBuildingSelector.vue?vue&type=script&lang=ts"
export * from "./ServiceBuildingSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports